export enum EPlatform {
  KIWIFY = 'KIWIFY',
  EVERMART = 'EVERMART',
  HOTMART = 'HOTMART',
  MONETIZZE = 'MONETIZZE',
  EDUZZ = 'EDUZZ',
  PAYT = 'PAYT',
}
